"use client";

import type { FC } from "react";
import { cn } from "utils";

export type PortfolioScreenshotRecognizeErrorProps = {
  message: string;
  className?: string;
};

/** Figma 89543:42168 — helper text below image list */
export const PortfolioScreenshotRecognizeError: FC<
  PortfolioScreenshotRecognizeErrorProps
> = ({ message, className }) => {
  return (
    <div
      className={cn("flex min-h-4 items-center px-1", className)}
      data-testid="portfolio-screenshot-recognize-error"
      role="alert"
    >
      <p className="body_s w-full text-content_accent2_primary">{message}</p>
    </div>
  );
};
